/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DirectUploadPresignedLinkRequestDto } from '../model/directUploadPresignedLinkRequestDto';
import { DirectUploadPresignedLinkResponseDto } from '../model/directUploadPresignedLinkResponseDto';
import { FileDownloadDto } from '../model/fileDownloadDto';
import { ResolveFileNameRequestDto } from '../model/resolveFileNameRequestDto';
import { SaveDirectUploadFileRequestDto } from '../model/saveDirectUploadFileRequestDto';
import { UpdateWorkspaceFileDto } from '../model/updateWorkspaceFileDto';
import { WorkspaceFileDto } from '../model/workspaceFileDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WorkspaceFileService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public archiveFiles(body?: Array<string>, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public archiveFiles(body?: Array<string>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public archiveFiles(body?: Array<string>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public archiveFiles(body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/files/archive`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ensureDownloadHeader(fileId: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public ensureDownloadHeader(fileId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public ensureDownloadHeader(fileId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public ensureDownloadHeader(fileId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling ensureDownloadHeader.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/workspace/files/${encodeURIComponent(String(fileId))}/ensure-download-header`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDownloadUrl(fileId: string, observe?: 'body', reportProgress?: boolean): Promise<FileDownloadDto>;
    public getDownloadUrl(fileId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<FileDownloadDto>>;
    public getDownloadUrl(fileId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<FileDownloadDto>>;
    public getDownloadUrl(fileId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling getDownloadUrl.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/workspace/files/${encodeURIComponent(String(fileId))}/download`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFileById(fileId: string, observe?: 'body', reportProgress?: boolean): Promise<WorkspaceFileDto>;
    public getFileById(fileId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<WorkspaceFileDto>>;
    public getFileById(fileId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<WorkspaceFileDto>>;
    public getFileById(fileId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling getFileById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/workspace/files/${encodeURIComponent(String(fileId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilesByWorkspace(workspaceId: string, type?: string, observe?: 'body', reportProgress?: boolean): Promise<Array<WorkspaceFileDto>>;
    public getFilesByWorkspace(workspaceId: string, type?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<WorkspaceFileDto>>>;
    public getFilesByWorkspace(workspaceId: string, type?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<WorkspaceFileDto>>>;
    public getFilesByWorkspace(workspaceId: string, type?: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling getFilesByWorkspace.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('Type', <any>type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/workspace/${encodeURIComponent(String(workspaceId))}/files`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPresignedUploadLink(workspaceId: string, body?: DirectUploadPresignedLinkRequestDto, observe?: 'body', reportProgress?: boolean): Promise<DirectUploadPresignedLinkResponseDto>;
    public getPresignedUploadLink(workspaceId: string, body?: DirectUploadPresignedLinkRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<DirectUploadPresignedLinkResponseDto>>;
    public getPresignedUploadLink(workspaceId: string, body?: DirectUploadPresignedLinkRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<DirectUploadPresignedLinkResponseDto>>;
    public getPresignedUploadLink(workspaceId: string, body?: DirectUploadPresignedLinkRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling getPresignedUploadLink.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/${encodeURIComponent(String(workspaceId))}/files/direct-upload/presigned-link`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pinFiles(body?: Array<string>, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public pinFiles(body?: Array<string>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public pinFiles(body?: Array<string>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public pinFiles(body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/files/pin`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resolveFileName(workspaceId: string, body?: ResolveFileNameRequestDto, observe?: 'body', reportProgress?: boolean): Promise<string>;
    public resolveFileName(workspaceId: string, body?: ResolveFileNameRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<string>>;
    public resolveFileName(workspaceId: string, body?: ResolveFileNameRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<string>>;
    public resolveFileName(workspaceId: string, body?: ResolveFileNameRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling resolveFileName.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/${encodeURIComponent(String(workspaceId))}/files/resolve-name`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public retransmitFile(fileId: string, observe?: 'body', reportProgress?: boolean): Promise<WorkspaceFileDto>;
    public retransmitFile(fileId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<WorkspaceFileDto>>;
    public retransmitFile(fileId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<WorkspaceFileDto>>;
    public retransmitFile(fileId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling retransmitFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/workspace/files/${encodeURIComponent(String(fileId))}/retransmit`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveDirectUploadFile(workspaceId: string, body?: SaveDirectUploadFileRequestDto, observe?: 'body', reportProgress?: boolean): Promise<WorkspaceFileDto>;
    public saveDirectUploadFile(workspaceId: string, body?: SaveDirectUploadFileRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<WorkspaceFileDto>>;
    public saveDirectUploadFile(workspaceId: string, body?: SaveDirectUploadFileRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<WorkspaceFileDto>>;
    public saveDirectUploadFile(workspaceId: string, body?: SaveDirectUploadFileRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling saveDirectUploadFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/${encodeURIComponent(String(workspaceId))}/files/direct-upload`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unArchiveFiles(body?: Array<string>, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public unArchiveFiles(body?: Array<string>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public unArchiveFiles(body?: Array<string>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public unArchiveFiles(body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/files/unarchive`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unpinFiles(body?: Array<string>, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public unpinFiles(body?: Array<string>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public unpinFiles(body?: Array<string>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public unpinFiles(body?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/workspace/files/unpin`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param fileId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFile(fileId: string, body?: UpdateWorkspaceFileDto, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public updateFile(fileId: string, body?: UpdateWorkspaceFileDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public updateFile(fileId: string, body?: UpdateWorkspaceFileDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public updateFile(fileId: string, body?: UpdateWorkspaceFileDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling updateFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/workspace/files/${encodeURIComponent(String(fileId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFiles(body?: Array<UpdateWorkspaceFileDto>, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public updateFiles(body?: Array<UpdateWorkspaceFileDto>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public updateFiles(body?: Array<UpdateWorkspaceFileDto>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public updateFiles(body?: Array<UpdateWorkspaceFileDto>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/workspace/files/batch`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
